<template>
  <v-autocomplete
    :items="list"
    :loading="isLoading"
    :search-input.sync="search"
    :filter="() => true"
    item-text="name"
    :item-value="(item) => item.id"
    :label="label"
    v-bind="$attrs"
    hide-details="auto"
    @input="handleSearchInputChange"
    @change="handleChange"
  >
    <template v-slot:item="data">
      <template v-if="typeof data.item !== 'object'">
        <v-list-item-content v-text="data.item"></v-list-item-content>
      </template>
      <template v-else>
        <template>
          <v-list-item-content
            :class="{
              'text-muted':
                [1, 2].indexOf(data.item.house_user_type_id) === -1 &&
                data.item.house_user_type_id,
            }"
          >
            <v-list-item-title>
              {{ data.item.name }}
            </v-list-item-title>
            <v-list-item-subtitle>
              <template v-if="data.item.block">
                {{ data.item.block }}
                <span v-if="data.item.door_number">
                  - {{ data.item.door_number }}
                </span>
              </template>
              <template v-if="data.item.house_user_type && !houseId">
                | {{ data.item.house_user_type }}
              </template>
              <template v-if="data.item.house_user_type_id && houseId">
                | {{ $t("house.user_type." + data.item.house_user_type_id) }}
              </template>
              <template v-if="data.item.is_staying">
                | Burada oturuyor
              </template>
              <template v-if="data.item.is_spokesperson">
                | <strong>İlgili Kişi</strong>
              </template>
            </v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
import { buildSearchParams } from "@/core/helpers";
import { debounce } from "@/core/plugins/debounce";

export default {
  props: {
    clusterId: {
      type: Number,
      required: true,
      default: null,
    },
    houseId: {
      type: Number,
      required: false,
      default: null,
    },
    extraParams: {
      type: Object,
      required: false,
      default: () => {},
    },
    label: {
      type: String,
      required: false,
      default: "Kişi seçin",
    },
  },
  watch: {
    search: debounce(function () {
      if (this.firstLoad) {
        this.firstLoad = false;
        return;
      }

      this.loadList();
    }, 250),
    clusterId() {
      this.search = null;
      this.loadList();
    },
    houseId() {
      this.search = null;
      this.loadList();
    },
    extraParams() {
      this.search = null;
      this.loadList();
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.loadList();
    });
  },
  data() {
    return {
      list: [],
      isLoading: false,
      search: null,
      selectedName: null,
      selectedItem: {},
      firstLoad: null,
    };
  },
  methods: {
    loadList() {
      if (this.isLoading || !this.clusterId) {
        return;
      }

      if (
        this.search &&
        (this.search === this.selectedName ||
          this.search === this.selectedItem.name)
      ) {
        return;
      }

      this.isLoading = true;

      const params = buildSearchParams(Object.assign({}, this.extraParams));

      if (this.houseId !== null) {
        params.house_id = this.houseId;
      }

      if (this.search) {
        params.query = this.search;
      }

      params.per_page = 1000;

      this.$api
        .query(`clusters/${this.clusterId}/residents`, { params })
        .then((response) => {
          this.list = response.data.data;
        })
        .catch((error) => {
          this.handleError(error);
        })
        .finally(() => {
          this.isLoading = false;
          if (this.firstLoad === null) {
            this.firstLoad = true;
            setTimeout(() => {
              this.firstLoad = false;
            }, 300);
          }
        });
    },
    handleChange(selectedId) {
      if (!selectedId) {
        this.selectedItem = {};
        this.$emit("change:option", { id: null, item: null });
        this.search = null;
        return false;
      }
      let selectedItem;

      for (const index in this.list) {
        if (this.list[index].id === selectedId) {
          selectedItem = Object.assign(this.list[index]);
          this.selectedItem = selectedItem;
          break;
        }
      }

      this.$emit("change:option", {
        id: selectedId,
        item: selectedItem,
      });
      this.$emit("input", selectedId);
      this.$emit("change", selectedId);

      this.selectedName = selectedItem.name;

      this.isLoading = true;
      this.$nextTick(() => {
        this.isLoading = false;
      });

      return false;
    },
    /**
     * Adds a new option to result list.
     * @param  {Object} item User Object
     * @return {Boolean}      True if added, false if already exists
     */
    pushOption(item) {
      for (const index in this.list) {
        if (this.list[index].id === item.id) {
          return false;
        }
      }
      this.list.push(item);

      return true;
    },
  },
};
</script>
